import LandingPage from './ui/LandingPage';

export { LandingPage };
